import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ItemGroupProps } from 'types/ItemGroupProps';
import * as S from './styles';

interface MediaYoutubeProps {
  data: ItemGroupProps;
  phoneWidth: number;
}

export default function MediaYoutube({ data }: MediaYoutubeProps) {
  const { t } = useTranslation();
  const [showVideo, setShowVideo] = useState(true);

  useEffect(() => {
    if (!showVideo) {
      setTimeout(() => {
        setShowVideo(true);
      }, 5000);
    }
  }, [showVideo]);

  return (
    <S.container data-testid="container">
      {data?.items[0]?.redirect_value ? (
        <S.videoEmbed
          onMouseOver={() => setShowVideo(false)}
          onMouseOut={() => setShowVideo(true)}
        >
          <iframe
            title={`WebView ${data.name || 0}`}
            src={data?.items[0]?.redirect_value}
            allow="fullscreen; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </S.videoEmbed>
      ) : (
        <S.noData>
          <p>{t('noData')}</p>
        </S.noData>
      )}
      <S.notice>
        <p>Haga clic aquí para editar el vídeo</p>
      </S.notice>
    </S.container>
  );
}
